/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Faq_1_QuestionInputs */

const en_svc_n8n_faq_1_question = /** @type {(inputs: Svc_N8n_Faq_1_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you an n8n agency?`)
};

const lv_svc_n8n_faq_1_question = /** @type {(inputs: Svc_N8n_Faq_1_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai Jūs esat n8n aģentūra?`)
};

/**
* | output |
* | --- |
* | "Are you an n8n agency?" |
*
* @param {Svc_N8n_Faq_1_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_faq_1_question = /** @type {((inputs?: Svc_N8n_Faq_1_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Faq_1_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_faq_1_question(inputs)
	return en_svc_n8n_faq_1_question(inputs)
});